import { useState } from "react";

const AccidentModal = ({ vehicle, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T')[0],
    time: '',
    location: '',
    description: '',
    damage_level: 'minor',
    police_report: false,
    injuries: false,
    other_party_involved: false,
    other_party_info: ''
  });

  const handleSubmit = () => {
    if (!formData.date || !formData.location || !formData.description) {
      return;
    }
    onSave(vehicle.vehicle_id, formData);
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-slate-800 rounded-xl border border-slate-700 w-full max-w-lg max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="p-6 border-b border-slate-700">
          <h3 className="text-xl font-bold text-white">Registar Sinistro</h3>
          <p className="text-sm text-slate-400 mt-1">{vehicle.brand} {vehicle.model} - {vehicle.license_plate}</p>
        </div>
        <div className="p-6 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Data *</label>
              <input
                type="date"
                value={formData.date}
                onChange={e => setFormData({...formData, date: e.target.value})}
                className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Hora</label>
              <input
                type="time"
                value={formData.time}
                onChange={e => setFormData({...formData, time: e.target.value})}
                className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              />
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Local *</label>
            <input
              type="text"
              value={formData.location}
              onChange={e => setFormData({...formData, location: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              placeholder="Ex: Av. da Liberdade, Lisboa"
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Descrição do Sinistro *</label>
            <textarea
              value={formData.description}
              onChange={e => setFormData({...formData, description: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              rows={3}
              placeholder="Descreva como ocorreu o sinistro..."
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Nível de Danos</label>
            <select
              value={formData.damage_level}
              onChange={e => setFormData({...formData, damage_level: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
            >
              <option value="minor">Ligeiro (riscos, amolgadelas pequenas)</option>
              <option value="moderate">Moderado (danos estruturais menores)</option>
              <option value="major">Grave (danos estruturais significativos)</option>
              <option value="total_loss">Perda Total</option>
            </select>
          </div>
          
          <div className="space-y-2">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={formData.police_report}
                onChange={e => setFormData({...formData, police_report: e.target.checked})}
                className="w-4 h-4 rounded"
              />
              <span className="text-sm text-slate-300">Participação Policial Elaborada</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={formData.injuries}
                onChange={e => setFormData({...formData, injuries: e.target.checked})}
                className="w-4 h-4 rounded"
              />
              <span className="text-sm text-slate-300">Houve Feridos</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={formData.other_party_involved}
                onChange={e => setFormData({...formData, other_party_involved: e.target.checked})}
                className="w-4 h-4 rounded"
              />
              <span className="text-sm text-slate-300">Outro Veículo Envolvido</span>
            </label>
          </div>
          
          {formData.other_party_involved && (
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Informação do Outro Veículo</label>
              <textarea
                value={formData.other_party_info}
                onChange={e => setFormData({...formData, other_party_info: e.target.value})}
                className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
                rows={2}
                placeholder="Matrícula, marca/modelo, dados do condutor..."
              />
            </div>
          )}
          
          <div className="p-4 bg-red-900/30 border border-red-700 rounded-lg">
            <p className="text-sm text-red-300">
              Após registar o sinistro, deve carregar a DAA (Declaração Amigável de Acidente) 
              no prazo máximo de 5 dias úteis.
            </p>
          </div>
        </div>
        
        <div className="p-6 border-t border-slate-700 flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 rounded-lg bg-slate-700 text-white hover:bg-slate-600">
            Cancelar
          </button>
          <button
            onClick={handleSubmit}
            disabled={!formData.date || !formData.location || !formData.description}
            className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-500 disabled:opacity-50"
          >
            Registar Sinistro
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccidentModal;
